"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeInt24BitData = exports.decodeUint24BitData = exports.decodeUint16BitData = exports.decodeUint12BitData = exports.exponentialBackOff = exports.observableCharacteristic = exports.decodeResponse = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const text_encoding_1 = require("text-encoding");
const delay_1 = __importDefault(require("delay"));
function decodeResponse(bytes) {
    return new text_encoding_1.TextDecoder().decode(bytes.subarray(1, 1 + bytes[0]));
}
exports.decodeResponse = decodeResponse;
// TODO: deprecate
async function observableCharacteristic(characteristic) {
    var _a;
    await characteristic.startNotifications();
    // @ts-ignore
    const disconnected = rxjs_1.fromEvent((_a = characteristic.service) === null || _a === void 0 ? void 0 : _a.device, 'gattserverdisconnected');
    // @ts-ignore
    return rxjs_1.fromEvent(characteristic, 'characteristicvaluechanged').pipe(operators_1.takeUntil(disconnected), operators_1.map((e) => e.target.value));
}
exports.observableCharacteristic = observableCharacteristic;
async function exponentialBackOff(n, wait, toTry, onSuccess, onFail) {
    try {
        console.log(`Reconnect: ${n}, ${wait}`);
        const result = await toTry();
        onSuccess(result);
    }
    catch (e) {
        if (n === 0)
            return onFail();
        await delay_1.default(wait);
        exponentialBackOff(n - 1, wait * 2, toTry, onSuccess, onFail);
    }
}
exports.exponentialBackOff = exponentialBackOff;
function decodeUint12BitData(samples) {
    // data: 12 x samples[uint12]
    const samples12Bit = [];
    for (let i = 0; i < samples.length; i++) {
        if (i % 3 === 0) {
            samples12Bit.push((samples[i] << 4) | (samples[i + 1] >> 4));
        }
        else {
            samples12Bit.push(((samples[i] & 0xf) << 8) | samples[i + 1]);
            i++;
        }
    }
    return samples12Bit;
}
exports.decodeUint12BitData = decodeUint12BitData;
function decodeUint16BitData(samples) {
    const samples16Bit = [];
    for (let i = 0; i < samples.length; i += 2) {
        samples16Bit.push((samples[i] << 8) | samples[i + 1]);
    }
    return samples16Bit;
}
exports.decodeUint16BitData = decodeUint16BitData;
function decodeUint24BitData(samples) {
    // data: 6 x samples[uint24]
    const samples24Bit = [];
    for (let i = 0; i < samples.length; i += 3) {
        samples24Bit.push((samples[i] << 16) | (samples[i + 1] << 8) | samples[i + 2]);
    }
    return samples24Bit;
}
exports.decodeUint24BitData = decodeUint24BitData;
function decodeInt24BitData(samples) {
    // data: 6 x samples[uint24]
    const samples24Bit = [];
    for (let i = 0; i < samples.length; i += 3) {
        const uInt32Sample = (samples[i] << 16) | (samples[i + 1] << 8) | samples[i + 2];
        const temp = uInt32Sample & 0xffffff;
        const int24Sample = temp - ((temp >> 23) << 24);
        samples24Bit.push(int24Sample);
    }
    return samples24Bit;
}
exports.decodeInt24BitData = decodeInt24BitData;
//# sourceMappingURL=ble-utils.js.map